var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('nav-item',{attrs:{"expanded":_vm.expanded,"icon":"mdi-chat","text":"Live Chat"},on:{"click":_vm.toggleChat}}),_c('div',{attrs:{"id":"mwChatWrapper"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }